import { Link } from "react-router";
import Picture from "../Picture/Picture.jsx";
import styles from "./PersonCard.module.css";
import { PORTRAIT_VERSION } from "../../lib/assetVersions.js";

/**
 * One person. The name links to their page and the whole card is its target, except the
 * LinkedIn link, which sits above it. `size`: "lead" adds their one-line bio, "member"
 * their location, "compact" is face, name and role.
 */
export default function PersonCard({ person, size = "member" }) {
  const lead = size === "lead";
  return (
    <article className={`${styles.person} ${styles[size]}`}>
      {person.photo ? (
        <Picture
          src={person.photo}
          alt={person.imageAlt || `Portrait of ${person.name}`}
          ratio={lead ? "4 / 5" : "1 / 1"}
          widths={[320, 640, 800]}
          fallbackWidth={640}
          sizes={lead ? "(min-width: 64rem) 26vw, 90vw" : "(min-width: 64rem) 14vw, 45vw"}
          className={styles.photo}
          version={PORTRAIT_VERSION}
        />
      ) : null}
      <h3 className={styles.name}>
        <Link to={`/about/team/${person.slug}`} className={styles.nameLink}>
          {person.name}
        </Link>
      </h3>
      <p className={styles.role}>{person.role}</p>
      {size === "member" && person.location ? (
        <p className={styles.location}>{person.location}</p>
      ) : null}
      {lead ? <p className={styles.bio}>{person.description}</p> : null}
      {size !== "compact" && person.linkedin ? (
        <a
          href={person.linkedin}
          className={styles.linkedin}
          target="_blank"
          rel="noreferrer"
          aria-label={`${person.name} on LinkedIn`}
        >
          LinkedIn
        </a>
      ) : null}
    </article>
  );
}
